import React from 'react';
import styled from 'styled-components';
import {
  ErrorMessage, FormikValues, FormikErrors, FormikTouched,
} from 'formik';

import { Checkbox } from '../../../fields/Checkbox';
import { CheckboxLabel } from '../../CheckboxLabel';
import { ReviewFormValues } from '../types';
import { ErrorMessageContainer } from '../../../fields/common/ErrorMessageContainer';

const CheckboxRow = styled.div`
  margin: 24px 0;
`;

type LegalFieldProps = {
  values: FormikValues,
  errors: FormikErrors<ReviewFormValues>,
  touched: FormikTouched<ReviewFormValues>,
  handleChange(e: React.ChangeEvent): void,
};

const LegalField = ({
  values, errors, touched, handleChange,
}: LegalFieldProps) => (
  <CheckboxRow>
    <Checkbox
      name="isAgreed"
      label={<CheckboxLabel />}
      isChecked={values.isAgreed}
      onChange={handleChange}
      error={errors.isAgreed && touched.isAgreed}
    />
    <ErrorMessage component={ErrorMessageContainer} name="isAgreed" />
  </CheckboxRow>
);

export { LegalField };
